import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

class ScaricaArchivioController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'ArchiSmallServices',
        'store'
    ];
    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private $http: ng.IHttpService,
        private configuration: any,
        private ArchiSmallServices: ArchiSmallServices,
        private store: ng.a0.storage.IStoreService
    ) {
        ArchiSmallServices.getUnsubscriptionArchives('1')
            .then((response: any) => {
                if ($rootScope.archidriveArchives.length > 0) {
                    ng.forEach(response, (value, key) => {
                        let archiveExists = $rootScope.checkIfArchiveExists(value, 'archidriveArchives');

                        if (!archiveExists) {
                            $rootScope.archidriveArchives.unshift(value);
                        }
                    });
                } else {
                    $rootScope.archidriveArchives = response;
                }
            }, (error) => {
                $rootScope.alert('error', error);
            });

        $scope.download = function () {
            $rootScope.downloadFile(this.archive.storage_file.storage_path, this.archive.storage_file.name);
        };

        $scope.setDownloadedStatus = function () {
            this.archive.downloaded = true;

            ArchiSmallServices.updateUnsubscriptionArchiveDownloadedStatus(this.archive)
                .then((response: any) => {
                    // ??
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
    }
}

export const ScaricaArchivioComponent: ng.IComponentOptions = {
    template: require('./scarica-archivio.html'),
    controller: ScaricaArchivioController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/scarica-archivio/scarica-archivio.ts